export class TriviaQuestion {
  title: string = '';
  answers: TriviaAnswer[] = [];
}

export class TriviaAnswer {
  title: string = '';
  score: number = 0;
}
